import type {
  ArgusSchedule,
  ArgusScheduleStatus,
  ListArgusSchedulesResponse,
} from "../../types/argus";
import { useApiQuery } from "../use-api-query";

interface UseListArgusSchedulesOptions {
  enabled?: boolean;
}

export function useListArgusSchedules(
  instanceId: string | undefined,
  status: ArgusScheduleStatus,
  options: UseListArgusSchedulesOptions = {},
) {
  const { enabled = true } = options;

  const query = useApiQuery<ListArgusSchedulesResponse>(
    `/client/argus/schedules?status=${status}&limit=100`,
    {
      enabled: enabled && !!instanceId,
      refetchInterval: 10_000,
    },
  );

  const all: ArgusSchedule[] = query.data?.schedules ?? [];
  const forInstance = all.filter((s) => s.instance_id === instanceId);
  const orgWide = all.filter((s) => s.instance_id === null);

  return { ...query, forInstance, orgWide, all };
}
